import { render, staticRenderFns } from "./StatusMappingsTab.vue?vue&type=template&id=621584ca&scoped=true&"
import script from "./StatusMappingsTab.vue?vue&type=script&lang=js&"
export * from "./StatusMappingsTab.vue?vue&type=script&lang=js&"
import style0 from "./StatusMappingsTab.vue?vue&type=style&index=0&id=621584ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621584ca",
  null
  
)

export default component.exports